import { render } from "./SobreGA.vue?vue&type=template&id=4dbe7a10&scoped=true"
import script from "./SobreGA.vue?vue&type=script&lang=js"
export * from "./SobreGA.vue?vue&type=script&lang=js"

import "./SobreGA.vue?vue&type=style&index=0&id=4dbe7a10&scoped=true&lang=css"

import exportComponent from "/var/www/site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dbe7a10"]])

export default __exports__